/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Approvals_Badge_LabelInputs */



/**
* | output |
* | --- |
* | "{count} runs waiting for your approval" |
*
* @param {Agent_Approvals_Badge_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_approvals_badge_label = /** @type {((inputs: Agent_Approvals_Badge_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Approvals_Badge_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Läufe warten auf Ihre Freigabe`)
	return /** @type {LocalizedString} */ (`${i?.count} runs waiting for your approval`)
});